<!-- aria-live="off": anunciar cada segundo sería ruido para lectores de
     pantalla; los avisos importantes (expiración) los da el consumidor. -->
<span class="countdown" role="timer" aria-live="off">{{ text() }}</span>
